<template>
  <div id="eap-redesign" :class="{ 'eap--dark': darkMode }" :style="pageStyle">
    <svg class="eap-sprite" width="0" height="0" aria-hidden="true">
      <defs>
        <symbol id="eap-icon-heart" viewBox="0 0 24 24">
          <path
            d="M12 21s-7-4.4-9.3-9A5.4 5.4 0 0 1 12 6a5.4 5.4 0 0 1 9.3 6c-2.3 4.6-9.3 9-9.3 9z"
            fill="none"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </symbol>
        <symbol id="eap-icon-video" viewBox="0 0 24 24">
          <g
            fill="none"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <rect x="2" y="3" width="20" height="14" rx="2" />
            <path d="M8 21h8M12 17v4" />
            <circle cx="12" cy="8.5" r="2.5" />
            <path d="M7.5 14.5c.7-1.9 2.5-3 4.5-3s3.8 1.1 4.5 3" />
          </g>
        </symbol>
        <symbol id="eap-icon-chat" viewBox="0 0 24 24">
          <g
            fill="none"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path
              d="M21 11.5a8.4 8.4 0 0 1-12.3 7.4L3 21l2.1-5.4A8.4 8.4 0 1 1 21 11.5z"
            />
            <path
              d="M8.5 11.5h.01M12 11.5h.01M15.5 11.5h.01"
              stroke-width="2.6"
            />
          </g>
        </symbol>
        <symbol id="eap-icon-whatsapp" viewBox="0 0 24 24">
          <g
            fill="none"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M3.5 20.5l1.3-4.2A8.5 8.5 0 1 1 8 19.3z" />
            <path
              d="M9 8.5c0 3.5 3 6.5 6.5 6.5l1-1.6-2-1-1 .8c-1-.4-2.2-1.6-2.6-2.6l.8-1-1-2z"
            />
          </g>
        </symbol>
        <symbol id="eap-icon-sms" viewBox="0 0 24 24">
          <g
            fill="none"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <rect x="3" y="4" width="18" height="13" rx="3" />
            <path d="M8 21l3-4M7.5 10.5h9M7.5 13.5h5" />
          </g>
        </symbol>
        <symbol id="eap-icon-phone" viewBox="0 0 24 24">
          <path
            d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z"
            fill="none"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </symbol>
        <symbol id="eap-icon-arrow" viewBox="0 0 24 24">
          <path
            d="M5 12h14M13 6l6 6-6 6"
            fill="none"
            stroke="currentColor"
            stroke-width="2.2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </symbol>
        <symbol id="eap-icon-chevron" viewBox="0 0 24 24">
          <path
            d="M9 6l6 6-6 6"
            fill="none"
            stroke="currentColor"
            stroke-width="2.2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </symbol>
        <symbol id="eap-icon-down" viewBox="0 0 24 24">
          <path
            d="M12 5v14M6 13l6 6 6-6"
            fill="none"
            stroke="currentColor"
            stroke-width="2.2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </symbol>
        <symbol id="eap-icon-lock" viewBox="0 0 24 24">
          <g
            fill="none"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <rect x="4" y="11" width="16" height="10" rx="2" />
            <path d="M8 11V7a4 4 0 0 1 8 0v4" />
          </g>
        </symbol>
        <symbol id="eap-icon-clock" viewBox="0 0 24 24">
          <g
            fill="none"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <circle cx="12" cy="12" r="9.5" />
            <path d="M12 6.5V12l3.5 2" />
          </g>
        </symbol>
        <symbol id="eap-icon-brain" viewBox="0 0 24 24">
          <g
            fill="none"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path
              d="M9 4.5a3 3 0 0 0-5 2.2 3 3 0 0 0-1 5 3.2 3.2 0 0 0 2 5.3 3 3 0 0 0 5 1.5V4.5z"
            />
            <path
              d="M15 4.5a3 3 0 0 1 5 2.2 3 3 0 0 1 1 5 3.2 3.2 0 0 1-2 5.3 3 3 0 0 1-5 1.5V4.5z"
            />
            <path d="M10 4.5h4M10 19h4" />
          </g>
        </symbol>
        <symbol id="eap-icon-scale" viewBox="0 0 24 24">
          <g
            fill="none"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path
              d="M12 3v18M7 21h10M5 7h14M5 7l-3 7a3 3 0 0 0 6 0zM19 7l-3 7a3 3 0 0 0 6 0z"
            />
          </g>
        </symbol>
        <symbol id="eap-icon-briefcase" viewBox="0 0 24 24">
          <g
            fill="none"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <rect x="3" y="7" width="18" height="13" rx="2" />
            <path d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2M3 13h18" />
          </g>
        </symbol>
        <symbol id="eap-icon-coin" viewBox="0 0 24 24">
          <g
            fill="none"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <circle cx="12" cy="12" r="9.5" />
            <path
              d="M15 8.5c-.6-.9-1.7-1.5-3-1.5-1.9 0-3 1-3 2.4 0 3.3 6 1.8 6 5.1 0 1.4-1.2 2.5-3 2.5-1.4 0-2.6-.6-3.2-1.6M12 5.5V7M12 17v1.5"
            />
          </g>
        </symbol>
        <symbol id="eap-icon-compass" viewBox="0 0 24 24">
          <g
            fill="none"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <circle cx="12" cy="12" r="9.5" />
            <path d="M15.8 8.2l-2.2 5.4-5.4 2.2 2.2-5.4z" />
          </g>
        </symbol>
        <symbol id="eap-icon-cart" viewBox="0 0 24 24">
          <g
            fill="none"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M2.5 3.5h2.6l2.3 11h11l2-7.5H6.2" />
            <circle cx="9" cy="19.5" r="1.4" />
            <circle cx="17" cy="19.5" r="1.4" />
          </g>
        </symbol>
        <symbol id="eap-icon-handshake" viewBox="0 0 24 24">
          <g
            fill="none"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path
              d="M2 8l3-2 4 1.5M22 8l-3-2-5 1.5-4 3.2a1.5 1.5 0 0 0 2 2.2l2-1.4 4.6 4"
            />
            <path
              d="M5 6v8l5 4.5a1.4 1.4 0 0 0 2-2M19 6v8l-2.6 2.3M9.5 16l1.5 1.4M12 14.5l2 1.8"
            />
          </g>
        </symbol>
        <symbol id="eap-icon-globe" viewBox="0 0 24 24">
          <g
            fill="none"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <circle cx="12" cy="12" r="9.5" />
            <path
              d="M2.5 12h19M12 2.5c2.5 2.6 3.8 5.8 3.8 9.5s-1.3 6.9-3.8 9.5c-2.5-2.6-3.8-5.8-3.8-9.5S9.5 5.1 12 2.5z"
            />
          </g>
        </symbol>
        <symbol id="eap-icon-parent" viewBox="0 0 24 24">
          <g
            fill="none"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <circle cx="9" cy="5" r="2.5" />
            <circle cx="17" cy="11" r="1.8" />
            <path
              d="M5 21v-6.5a4 4 0 0 1 8 0V21M14.5 21v-3a2.5 2.5 0 0 1 5 0v3"
            />
          </g>
        </symbol>
        <symbol id="eap-icon-flower" viewBox="0 0 24 24">
          <g
            fill="none"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <circle cx="12" cy="9" r="2.2" />
            <path
              d="M12 6.8C11 4 12 2.5 12 2.5s1 1.5 0 4.3M14.2 9c2.8-1 4.3 0 4.3 0s-1.5 1-4.3 0M12 11.2c1 2.8 0 4.3 0 4.3s-1-1.5 0-4.3M9.8 9C7 10 5.5 9 5.5 9s1.5-1 4.3 0M12 15.5v6M12 19c-2-.3-3.5-1.5-4-3.3M12 19c2-.3 3.5-1.5 4-3.3"
            />
          </g>
        </symbol>
        <symbol id="eap-icon-shield" viewBox="0 0 24 24">
          <g
            fill="none"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M12 2.5l8 3v6c0 4.8-3.4 8.6-8 10-4.6-1.4-8-5.2-8-10v-6z" />
            <path d="M8.5 12l2.5 2.5 4.5-5" />
          </g>
        </symbol>
        <symbol id="eap-icon-calendar" viewBox="0 0 24 24">
          <g
            fill="none"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <rect x="3" y="4" width="18" height="17" rx="2" />
            <path d="M16 2v4M8 2v4M3 10h18M12 13.5v4M10 15.5h4" />
          </g>
        </symbol>
      </defs>
    </svg>

    <div v-if="contentLoading" class="eap-loading">
      <b-spinner></b-spinner>
    </div>

    <main v-else-if="eapCustomisation" class="eap-layout">
      <section
        class="eap-hero"
        :class="{ 'eap-hero--intro-expanded': isIntroExpanded }"
        aria-labelledby="eap-title"
      >
        <div class="eap-hero__copy">
          <span class="eap-eyebrow">
            <span class="eap-eyebrow__dot">
              <svg class="eap-icon" width="14" height="14" aria-hidden="true">
                <use href="#eap-icon-heart" />
              </svg>
            </span>
            {{ text.eyebrow }}
          </span>
          <h1 id="eap-title" class="eap-hero__title">
            {{ titleParts.lead
            }}<span v-if="titleParts.emphasis" class="eap-gradient-text">{{
              titleParts.emphasis
            }}</span>
          </h1>
          <div class="eap-hero__intro-wrap">
            <div
              id="eap-intro"
              ref="intro"
              class="eap-hero__intro"
              :class="{
                'eap-hero__intro--collapsed': !isIntroExpanded,
                'eap-hero__intro--overflowing': isIntroOverflowing,
              }"
              v-html="defaults.eap_intro"
            ></div>
            <button
              v-if="isIntroOverflowing"
              type="button"
              class="eap-intro-toggle"
              aria-controls="eap-intro"
              :aria-expanded="String(isIntroExpanded)"
              @click="toggleIntro"
            >
              {{ isIntroExpanded ? text.intro.showLess : text.intro.readMore }}
              <svg
                class="eap-icon eap-intro-toggle__icon"
                width="14"
                height="14"
                aria-hidden="true"
              >
                <use href="#eap-icon-down" />
              </svg>
            </button>
          </div>
          <ul class="eap-chips" :aria-label="text.aboutServiceLabel">
            <li>
              <svg class="eap-icon" width="16" height="16" aria-hidden="true">
                <use href="#eap-icon-shield" />
              </svg>
              {{ text.highlights.covered }}
            </li>
            <li>
              <svg class="eap-icon" width="16" height="16" aria-hidden="true">
                <use href="#eap-icon-lock" />
              </svg>
              {{ text.highlights.confidential }}
            </li>
            <li>
              <svg class="eap-icon" width="16" height="16" aria-hidden="true">
                <use href="#eap-icon-clock" />
              </svg>
              {{ text.highlights.alwaysOpen }}
            </li>
          </ul>
          <div
            v-if="hasImmediateChannels || isDmhEnabled"
            class="eap-choices"
            :class="{
              'eap-choices--single': !(hasImmediateChannels && isDmhEnabled),
            }"
            role="group"
            :aria-label="text.choicesLabel"
          >
            <a
              v-if="hasImmediateChannels"
              class="eap-choice"
              href="#eap-channels"
              @click.prevent="showSupportOptions('Talk to someone now')"
            >
              <span class="eap-choice__top">
                <span class="eap-choice__icon">
                  <svg
                    class="eap-icon"
                    width="22"
                    height="22"
                    aria-hidden="true"
                  >
                    <use href="#eap-icon-phone" />
                  </svg>
                </span>
                <span class="eap-choice__badge"
                  ><span class="eap-choice__dot" aria-hidden="true"></span
                  >{{ text.talkNow.badge }}</span
                >
              </span>
              <strong class="eap-choice__title">{{
                text.talkNow.title
              }}</strong>
              <span class="eap-choice__copy">{{
                text.talkNow.description
              }}</span>
              <span class="eap-choice__cta">
                {{ text.talkNow.cta }}
                <svg class="eap-icon" width="16" height="16" aria-hidden="true">
                  <use href="#eap-icon-down" />
                </svg>
              </span>
            </a>
            <a
              v-if="isDmhEnabled"
              class="eap-choice"
              :href="dmhBookingPath"
              @click.prevent="bookAppointment('banner')"
            >
              <span class="eap-choice__top">
                <span class="eap-choice__icon">
                  <svg
                    class="eap-icon"
                    width="22"
                    height="22"
                    aria-hidden="true"
                  >
                    <use href="#eap-icon-calendar" />
                  </svg>
                </span>
              </span>
              <strong class="eap-choice__title">{{
                text.bookAppointment.title
              }}</strong>
              <span class="eap-choice__copy">{{
                text.bookAppointment.description
              }}</span>
              <span class="eap-choice__cta">
                {{ text.bookAppointment.cta }}
                <svg
                  class="eap-icon eap-icon--arrow"
                  width="16"
                  height="16"
                  aria-hidden="true"
                >
                  <use href="#eap-icon-arrow" />
                </svg>
              </span>
            </a>
          </div>
          <a
            v-if="hasImmediateChannels"
            class="eap-all-ways"
            href="#eap-channels"
            @click.prevent="showSupportOptions('See all ways to get support')"
          >
            {{ text.allWays }}
            <svg class="eap-icon" width="14" height="14" aria-hidden="true">
              <use href="#eap-icon-down" />
            </svg>
          </a>
        </div>
        <div class="eap-hero__media">
          <img
            class="eap-hero__image"
            src="/img/eap/eap-hero.jpg"
            :alt="text.heroImageAlt"
          />
          <div class="eap-float-card" aria-hidden="true">
            <span class="eap-pulse"></span>
            <div>
              <strong>{{ text.availableNow.title }}</strong>
              <span>{{ text.availableNow.description }}</span>
            </div>
          </div>
        </div>
      </section>

      <section
        v-if="appointmentCards.length"
        aria-labelledby="eap-appointments-title"
      >
        <div class="eap-section-head">
          <div>
            <div class="eap-kicker">{{ text.appointments.kicker }}</div>
            <h2 id="eap-appointments-title">{{ text.appointments.title }}</h2>
          </div>
        </div>
        <div class="eap-appointments" data-ph-mask>
          <article
            v-for="card in appointmentCards"
            :key="card.id"
            class="eap-appointment"
          >
            <div class="eap-date-tile" aria-hidden="true">
              <span class="eap-date-tile__month">{{ card.month }}</span>
              <span class="eap-date-tile__day">{{ card.day }}</span>
            </div>
            <div class="eap-appointment__meta">
              <h3>{{ card.title }}</h3>
              <p v-if="card.clinicianLine" class="eap-appointment__clinician">
                {{ card.clinicianLine }}
              </p>
              <span class="eap-time-chip">
                <svg class="eap-icon" width="14" height="14" aria-hidden="true">
                  <use href="#eap-icon-clock" />
                </svg>
                <span class="eap-sr-only">{{ card.fullDate }}, </span>
                {{ card.timeRange }}
              </span>
            </div>
            <div class="eap-appointment__actions">
              <button
                type="button"
                class="eap-button eap-button--outline"
                :aria-label="
                  `${text.appointments.addToCalendar}, ${card.accessibleSummary}`
                "
                @click="addToCalendar(card)"
              >
                <svg class="eap-icon" width="18" height="18" aria-hidden="true">
                  <use href="#eap-icon-calendar" />
                </svg>
                {{ text.appointments.addToCalendar }}
              </button>
              <a
                class="eap-button eap-button--primary"
                :href="card.joinPath"
                :aria-label="
                  `${text.appointments.joinSession}, ${card.accessibleSummary}`
                "
                @click.prevent="joinSession(card)"
              >
                {{ text.appointments.joinSession }}
                <svg
                  class="eap-icon eap-icon--arrow"
                  width="18"
                  height="18"
                  aria-hidden="true"
                >
                  <use href="#eap-icon-arrow" />
                </svg>
              </a>
            </div>
          </article>
        </div>
      </section>

      <section
        v-if="services.length"
        class="eap-reveal"
        aria-labelledby="eap-services-title"
      >
        <div class="eap-section-head">
          <div>
            <div class="eap-kicker">{{ text.services.kicker }}</div>
            <h2 id="eap-services-title">{{ text.services.title }}</h2>
          </div>
          <p>{{ text.services.description }}</p>
        </div>
        <ul class="eap-services">
          <li
            v-for="service in services"
            :key="service.title"
            class="eap-service"
          >
            <div class="eap-service__icon">
              <svg class="eap-icon" width="22" height="22" aria-hidden="true">
                <use :href="'#eap-icon-' + service.icon" />
              </svg>
            </div>
            <h3>{{ service.title }}</h3>
            <p v-if="service.key">
              {{ text.services.descriptions[service.key] }}
            </p>
          </li>
        </ul>
      </section>

      <section
        v-if="hasImmediateChannels || isDmhEnabled"
        id="eap-channels"
        ref="channels"
        class="eap-reveal"
        aria-labelledby="eap-channels-title"
      >
        <div class="eap-section-head">
          <div>
            <div class="eap-kicker">{{ text.channels.kicker }}</div>
            <h2 id="eap-channels-title">{{ text.channels.title }}</h2>
          </div>
          <p>{{ text.channels.description }}</p>
        </div>
        <div class="eap-bento">
          <article
            v-if="isPhoneTileShown"
            class="eap-tile eap-tile--contact"
            :class="{
              'eap-tile--full': !isMessagingTileShown,
              'eap-tile--highlight': isContactHighlighted,
            }"
          >
            <div class="eap-tile__top">
              <div class="eap-tile__icon">
                <svg class="eap-icon" width="28" height="28" aria-hidden="true">
                  <use href="#eap-icon-phone" />
                </svg>
              </div>
              <span class="eap-availability">{{
                text.channels.available
              }}</span>
            </div>
            <span class="eap-tile__label">{{ text.phone.label }}</span>
            <h3>{{ text.phone.title }}</h3>
            <p>{{ text.phone.description }}</p>
            <div class="eap-rows">
              <a
                v-for="(callNumber, index) in contactChannels.callNumbers"
                :key="callNumber.href + index"
                class="eap-row"
                :class="{ 'eap-row--primary': index === 0 }"
                :href="callNumber.href"
                :aria-label="
                  `${text.phone.callAriaLabel}, ${formatContactNumber(
                    callNumber,
                  )}`
                "
                @click="trackPhoneClicked(callNumber.region)"
              >
                <span class="eap-row__icon">
                  <svg
                    class="eap-icon"
                    width="18"
                    height="18"
                    aria-hidden="true"
                  >
                    <use href="#eap-icon-phone" />
                  </svg>
                </span>
                <span class="eap-row__text">
                  <small>{{ text.phone.callUs }}</small>
                  <b>{{ formatContactNumber(callNumber) }}</b>
                </span>
                <svg
                  class="eap-icon eap-row__chevron"
                  width="18"
                  height="18"
                  aria-hidden="true"
                >
                  <use href="#eap-icon-chevron" />
                </svg>
              </a>
              <div class="eap-note">
                <svg class="eap-icon" width="18" height="18" aria-hidden="true">
                  <use href="#eap-icon-briefcase" />
                </svg>
                <p>{{ text.phone.managerNote }}</p>
              </div>
            </div>
          </article>

          <article
            v-if="isMessagingTileShown"
            class="eap-tile eap-tile--contact"
            :class="{
              'eap-tile--full': !isPhoneTileShown,
              'eap-tile--highlight': isContactHighlighted,
            }"
          >
            <div class="eap-tile__top">
              <div class="eap-tile__icon">
                <svg class="eap-icon" width="28" height="28" aria-hidden="true">
                  <use href="#eap-icon-chat" />
                </svg>
              </div>
              <span class="eap-availability">{{
                text.channels.available
              }}</span>
            </div>
            <span class="eap-tile__label">{{ text.messaging.label }}</span>
            <h3>{{ text.messaging.title }}</h3>
            <p>{{ text.messaging.description }}</p>
            <div class="eap-rows">
              <component
                :is="row.href ? 'a' : 'button'"
                v-for="(row, index) in messagingRows"
                :key="row.key"
                class="eap-row"
                :class="{ 'eap-row--primary': index === 0 }"
                :href="row.href"
                :type="row.href ? null : 'button'"
                :target="row.opensNewTab ? '_blank' : null"
                :rel="row.opensNewTab ? 'noopener noreferrer' : null"
                :aria-label="row.ariaLabel"
                @click="
                  row.href
                    ? trackMessageClicked(row.channel, row.region)
                    : openLiveChat()
                "
              >
                <span class="eap-row__icon">
                  <svg
                    class="eap-icon"
                    width="18"
                    height="18"
                    aria-hidden="true"
                  >
                    <use :href="'#eap-icon-' + row.icon" />
                  </svg>
                </span>
                <span class="eap-row__text">
                  <small>{{ row.label }}</small>
                  <b>{{ row.value }}</b>
                </span>
                <svg
                  class="eap-icon eap-row__chevron"
                  width="18"
                  height="18"
                  aria-hidden="true"
                >
                  <use href="#eap-icon-chevron" />
                </svg>
              </component>
            </div>
          </article>

          <article v-if="isDmhEnabled" class="eap-tile eap-tile--dmh">
            <div class="eap-dmh__icon">
              <svg class="eap-icon" width="24" height="24" aria-hidden="true">
                <use href="#eap-icon-video" />
              </svg>
            </div>
            <div class="eap-dmh__body">
              <span class="eap-tile__label">{{ text.dmh.label }}</span>
              <h3>{{ text.dmh.title }}</h3>
              <p>{{ text.dmh.description }}</p>
              <ul class="eap-dmh__points">
                <li v-for="point in text.dmh.points" :key="point">
                  {{ point }}
                </li>
              </ul>
            </div>
            <a
              class="eap-button eap-button--outline"
              :href="dmhBookingPath"
              @click.prevent="bookAppointment('get_support')"
            >
              {{ text.dmh.cta }}
              <svg
                class="eap-icon eap-icon--arrow"
                width="18"
                height="18"
                aria-hidden="true"
              >
                <use href="#eap-icon-arrow" />
              </svg>
            </a>
          </article>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import axios from "axios";
import * as Sentry from "@sentry/vue";
import config from "../config/constants";
import { trackEvent } from "@/utils/analytics/analytics";
import {
  APPT_ADD_TO_CALENDAR_CLICKED,
  APPT_JOIN_CLICKED,
  EAP_BOOK_APPOINTMENT_CLICKED,
  EAP_GET_SUPPORT_CLICKED,
  EAP_INTRO_EXPANDED,
  EAP_LIVE_CHAT_OPENED,
  EAP_MESSAGE_CLICKED,
  EAP_PHONE_CLICKED,
} from "@/utils/analyticsEvents";
import { minutesToStart, toPhoneType } from "@/utils/eapAnalytics/eapAnalytics";
import { WEBCHAT_SCHEMA_VERSION } from "@/utils/webchat/webchat";
import { isAffirmative } from "@/utils/isAffirmative/isAffirmative";
import {
  extractEapContactChannels,
  hasMessagingChannel,
} from "@/utils/eapContactChannels/eapContactChannels";
import { selectEnabledEapServices } from "@/utils/eapServices/eapServices";
import {
  appointmentEndMs,
  buildCalendarEvent,
  selectUpcomingEapAppointments,
  withAppointmentInstants,
} from "@/utils/eapAppointments/eapAppointments";
import { getAppointmentTimeDisplay } from "@/utils/appointmentTimezone/appointmentTimezone";
import {
  deriveCtaTokens,
  resolveCtaColour,
} from "@/utils/eapCtaTheme/eapCtaTheme";

const TYPEFACES = {
  app: '"EapDMSans", DMSans, Arial, Helvetica, sans-serif',
  inter: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif',
};
// "app" keeps the portal's DMSans; switch to "inter" to use the prototype's typeface.
const EAP_TYPEFACE = "app";
const INTER_STYLESHEET_ID = "eap-inter-font";
const INTER_STYLESHEET_URL =
  "https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap";

const CONTACT_HIGHLIGHT_MS = 1800;
const CALENDAR_FILE_NAME = "appointment.ics";

// Core returns a null customisation for a client that has never saved one: show the
// programme with live chat rather than an empty page.
const UNCUSTOMISED_EAP = {
  defaults: { eap_title: "EAP", live_chat: true },
};

export default {
  name: "eap",
  data() {
    return {
      eapCustomisation: null,
      contentLoading: true,
      upcomingAppointments: [],
      themeBrandColour: null,
      isContactHighlighted: false,
      contactHighlightTimer: null,
      revealObserver: null,
      isIntroExpanded: false,
      isIntroOverflowing: false,
      introResizeFrame: null,
      isLiveChatStarting: false,
      webchatMessageHandler: null,
      webchatPort: null,
    };
  },
  mounted() {
    this.readThemeBrandColour();
    if (EAP_TYPEFACE === "inter") this.loadInterTypeface();
    this.getEapContent();
    this.getUpcomingAppointments();
    window.addEventListener("resize", this.scheduleIntroMeasure);
  },
  destroyed() {
    clearTimeout(this.contactHighlightTimer);
    window.removeEventListener("resize", this.scheduleIntroMeasure);
    cancelAnimationFrame(this.introResizeFrame);
    if (this.revealObserver) this.revealObserver.disconnect();
    const messageBirdWidget = document.getElementById("live-chat-widget");
    if (messageBirdWidget) messageBirdWidget.style.display = "none";
    const iframe = document.getElementById("twilio-webchat-iframe");
    if (iframe) iframe.style.display = "none";
    if (this.webchatMessageHandler) {
      window.removeEventListener("message", this.webchatMessageHandler);
      this.webchatMessageHandler = null;
    }
    // The iframe outlives this component (it lives on document.body); our end of the
    // channel doesn't.
    if (this.webchatPort) {
      this.webchatPort.onmessage = null;
      this.webchatPort.close();
      this.webchatPort = null;
    }
  },
  watch: {
    // A skin change swaps the theme class on the app root, so the compiled
    // --brand-primary only reflects it once that re-render has landed.
    skin() {
      this.$nextTick(this.readThemeBrandColour);
    },
  },
  methods: {
    readThemeBrandColour() {
      this.themeBrandColour = getComputedStyle(this.$el)
        .getPropertyValue("--brand-primary")
        .trim();
    },
    async getEapContent() {
      try {
        const res = await axios.post(
          config.api_env + "/application/api/u/customisations/get-eap-content",
          { user_id: this.$store.getters.user_id },
          config.options,
        );
        if (res.data.success) {
          this.eapCustomisation =
            res.data.eap_customisation ?? UNCUSTOMISED_EAP;
        }
      } catch (error) {
        Sentry.captureException(error);
      }
      this.contentLoading = false;
      this.$nextTick(() => {
        this.observeReveals();
        this.measureIntro();
      });
      // Line heights shift once the webfont lands.
      if (document.fonts) document.fonts.ready.then(this.measureIntro);
    },
    async getUpcomingAppointments() {
      try {
        const res = await this.api({ path: "api/u/dmh/get-all-appointments" });
        const appointments = withAppointmentInstants(
          (res && res.appointments) || [],
        );
        // Session looks in the store before fetching, so a booking made since the side
        // bar last loaded would otherwise read as "couldn't find this appointment".
        this.$store.commit("setAppointments", appointments);
        this.upcomingAppointments = selectUpcomingEapAppointments(appointments);
      } catch (error) {
        Sentry.captureException(error);
      }
    },
    // Long client intros collapse to a few lines so the support routes stay near the top.
    // Measured while collapsed, so an expanded intro keeps its toggle through a resize.
    measureIntro() {
      const intro = this.$refs.intro;
      if (!intro || this.isIntroExpanded) return;
      this.isIntroOverflowing = intro.scrollHeight > intro.clientHeight + 1;
    },
    scheduleIntroMeasure() {
      cancelAnimationFrame(this.introResizeFrame);
      this.introResizeFrame = requestAnimationFrame(this.measureIntro);
    },
    toggleIntro() {
      this.isIntroExpanded = !this.isIntroExpanded;
      if (this.isIntroExpanded) trackEvent(EAP_INTRO_EXPANDED);
    },
    loadInterTypeface() {
      if (document.getElementById(INTER_STYLESHEET_ID)) return;
      const stylesheet = document.createElement("link");
      stylesheet.id = INTER_STYLESHEET_ID;
      stylesheet.rel = "stylesheet";
      stylesheet.href = INTER_STYLESHEET_URL;
      document.head.appendChild(stylesheet);
    },
    // Sections fade up as they scroll into view; reduced motion skips the animation in CSS.
    observeReveals() {
      const sections = this.$el.querySelectorAll(".eap-reveal");
      if (!("IntersectionObserver" in window)) {
        sections.forEach((section) => section.classList.add("is-revealed"));
        return;
      }
      this.revealObserver = new IntersectionObserver(
        (entries) =>
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add("is-revealed");
            this.revealObserver.unobserve(entry.target);
          }),
        { rootMargin: "0px 0px -8% 0px" },
      );
      sections.forEach((section) => this.revealObserver.observe(section));
    },
    showSupportOptions(label) {
      trackEvent(EAP_GET_SUPPORT_CLICKED, {
        service: "eap",
        section: "banner",
        label,
      });
      const channels = this.$refs.channels;
      if (!channels) return;
      channels.classList.add("is-revealed");
      const prefersReducedMotion = window.matchMedia(
        "(prefers-reduced-motion: reduce)",
      ).matches;
      channels.scrollIntoView({
        behavior: prefersReducedMotion ? "auto" : "smooth",
      });
      if (label !== "Talk to someone now") return;
      clearTimeout(this.contactHighlightTimer);
      this.isContactHighlighted = true;
      this.contactHighlightTimer = setTimeout(() => {
        this.isContactHighlighted = false;
      }, CONTACT_HIGHLIGHT_MS);
    },
    bookAppointment(section) {
      trackEvent(EAP_BOOK_APPOINTMENT_CLICKED, { service: "eap", section });
      this.$router.push(this.dmhBookingPath);
    },
    appointmentEventProperties({ appointment }) {
      return {
        service: "dmh",
        section: "appointments",
        booking_id: appointment.appointmentId ?? null,
        minutes_to_start: minutesToStart(appointment.startDublinMs),
      };
    },
    joinSession(card) {
      trackEvent(APPT_JOIN_CLICKED, this.appointmentEventProperties(card));
      this.$router.push(card.joinPath);
    },
    addToCalendar(card) {
      const { appointment } = card;
      const joinUrl =
        window.location.origin + this.$router.resolve(card.joinPath).href;
      const calendarFile = buildCalendarEvent({
        uid: `${appointment.appointmentId}@spectrum.life`,
        title: card.clinicianLine
          ? `${card.title} ${card.clinicianLine}`
          : card.title,
        description: `${this.text.appointments.calendarJoinPrompt} ${joinUrl}`,
        url: joinUrl,
        startMs: appointment.startDublinMs,
        endMs: appointmentEndMs(appointment),
        createdMs: Date.now(),
      });
      // An .ics download hands the event to the device's default calendar app.
      const fileUrl = URL.createObjectURL(
        new Blob([calendarFile], { type: "text/calendar;charset=utf-8" }),
      );
      const link = document.createElement("a");
      link.href = fileUrl;
      link.download = CALENDAR_FILE_NAME;
      document.body.appendChild(link);
      link.click();
      link.remove();
      setTimeout(() => URL.revokeObjectURL(fileUrl), 0);
      trackEvent(
        APPT_ADD_TO_CALENDAR_CLICKED,
        this.appointmentEventProperties(card),
      );
    },
    trackPhoneClicked(region) {
      trackEvent(EAP_PHONE_CLICKED, {
        service: "eap",
        section: "get_support",
        phone_type: toPhoneType(region),
      });
    },
    trackMessageClicked(channel, region) {
      trackEvent(EAP_MESSAGE_CLICKED, {
        service: "eap",
        section: "get_support",
        channel,
        phone_type: toPhoneType(region),
      });
    },
    formatContactNumber({ region, number }) {
      return region ? `${region}: ${number}` : number;
    },
    async openLiveChat() {
      if (this.isLiveChatStarting) return;
      this.trackMessageClicked("live_chat", null);
      this.isLiveChatStarting = true;
      let useTwilioFlex = false;
      try {
        // v2 is a deliberately new key: builds that shipped against the old
        // `eap_twilio_flex_chat_web` send an init the webchat now rejects, so that key
        // stays off permanently and leaves them on MessageBird.
        const res = await this.api({
          path: "api/u/feature-flag",
          feature_flags: ["eap_twilio_flex_web_chat_v2"],
        });
        useTwilioFlex = !!(
          res &&
          res.feature_flags &&
          res.feature_flags.eap_twilio_flex_web_chat_v2
        );
      } catch {
        useTwilioFlex = false;
      }
      if (useTwilioFlex) {
        this.openTwilioWebchat();
      } else {
        this.openMessageBirdChat();
      }
      this.isLiveChatStarting = false;
    },
    openMessageBirdChat() {
      trackEvent(EAP_LIVE_CHAT_OPENED, { provider: "messagebird" });
      const widget = document.getElementById("live-chat-widget");
      if (widget) {
        widget.style.display = "initial";
        if (window.MessageBirdChatWidget)
          window.MessageBirdChatWidget.toggleChat();
        return;
      }
      const script = document.createElement("script");
      script.src = "/assets/salesforce_Script.js";
      script.type = "text/javascript";
      script.setAttribute("id", "sf-script");
      // The snippet defines a queueing stub, so the toggle is replayed once the widget boots.
      script.onload = () => {
        if (window.MessageBirdChatWidget)
          window.MessageBirdChatWidget.toggleChat();
      };
      document.head.appendChild(script);
    },
    openTwilioWebchat() {
      // VUE_APP_REGION / VUE_APP_WEBCHAT_URL absent or invalid — a build misconfiguration.
      // Refuse rather than guess the region (wrong Flex account) or throw on new URL()
      // below (CR-126).
      if (!config.webchat_region || !config.webchat_url) {
        Sentry.captureMessage(
          "Not opening Twilio webchat: VUE_APP_REGION or VUE_APP_WEBCHAT_URL missing/invalid",
          { level: "error", tags: { stage: "webchat_config" } },
        );
        return;
      }
      const webchatOrigin = new URL(config.webchat_url).origin;
      const existingIframe = document.getElementById("twilio-webchat-iframe");
      if (existingIframe && existingIframe.classList.contains("expanded")) {
        existingIframe.style.display = "block";
        return;
      }
      // The contract can only open the chat through autoOpen on its one-shot init, so a
      // collapsed iframe left from an earlier visit is replaced. The SDK keeps the
      // conversation in its own storage, so the fresh frame resumes it.
      if (existingIframe) existingIframe.remove();

      // Embed the hosted webchat, driven via the webchat:* contract
      // (mirrors live-webchat/src/contracts/embed.ts).
      const iframe = document.createElement("iframe");
      iframe.id = "twilio-webchat-iframe";
      const webchatUrl = new URL(config.webchat_url);
      // Clear the bottom-right a11y widget: 72 = its ~56px + a 16px gap; 16 off the edge.
      webchatUrl.searchParams.set("offsetBottom", "72");
      webchatUrl.searchParams.set("offsetRight", "16");
      iframe.src = webchatUrl.toString();
      iframe.title = "Live chat";
      // allow-scripts + allow-same-origin is only self-defeating for a SAME-origin
      // frame, which could reach our DOM and drop the attribute; this embed is
      // cross-origin. Both are needed anyway — an opaque origin breaks the SDK's
      // localStorage and sends its API calls with a null origin.
      // The value is in what's withheld, above all allow-top-navigation. popups and
      // downloads are for links and attachments in a conversation — retest before
      // dropping either.
      iframe.setAttribute(
        "sandbox",
        "allow-scripts allow-same-origin allow-forms allow-popups allow-downloads",
      );
      // Deny device APIs the webchat never needs.
      iframe.setAttribute("allow", "clipboard-write");
      document.body.appendChild(iframe);

      if (this.webchatMessageHandler) {
        window.removeEventListener("message", this.webchatMessageHandler);
      }
      // Only webchat:ready arrives over the window: it's the signal to open the channel,
      // so it can't travel over a port that doesn't exist yet. Everything else uses the
      // port (CR-130).
      const handler = (event) => {
        if (event.origin !== webchatOrigin) return;
        const message = event.data;
        if (!message || typeof message !== "object") return;
        if (message.type !== "webchat:ready") return;
        // A contract this build doesn't speak — ignore rather than half-understand it.
        if (message.v !== WEBCHAT_SCHEMA_VERSION) return;
        // Apply the offsets the webchat resolved (floating presentation only).
        if (typeof message.offsetBottom === "number") {
          iframe.style.setProperty(
            "--webchat-offset-bottom",
            `${message.offsetBottom}px`,
          );
        }
        if (typeof message.offsetRight === "number") {
          iframe.style.setProperty(
            "--webchat-offset-right",
            `${message.offsetRight}px`,
          );
        }
        this.openWebchatChannel(iframe, webchatOrigin);
      };
      window.addEventListener("message", handler);
      this.webchatMessageHandler = handler;
    },
    // Opens a private MessageChannel with the webchat and sends init over it, so the
    // token never crosses the broadcast window surface (CR-130 / receiver CR-129).
    openWebchatChannel(iframe, webchatOrigin) {
      if (!iframe.contentWindow) return;
      if (this.webchatPort) {
        this.webchatPort.onmessage = null;
        this.webchatPort.close();
      }
      const channel = new MessageChannel();
      this.webchatPort = channel.port1;
      channel.port1.onmessage = (event) =>
        this.onWebchatPortMessage(event.data, iframe);
      // port2 goes to the webchat; origin still pinned, and no payload on this message.
      iframe.contentWindow.postMessage(
        { type: "webchat:connect", v: WEBCHAT_SCHEMA_VERSION },
        webchatOrigin,
        [channel.port2],
      );
      // user_id is the oath_token — validated server-side, never sent to Twilio.
      // Booted by the member's "Use live chat" click, so it opens straight away.
      channel.port1.postMessage({
        type: "webchat:init",
        v: WEBCHAT_SCHEMA_VERSION,
        token: this.$store.getters.user_id,
        displayMode: "widget",
        autoOpen: true,
        // One deployment serves every QA env — tell it which backend issued the token.
        apiBaseUrl: new URL(config.api_env).origin,
        // Selects that region's Twilio config; derived from the same api_env (CR-126).
        region: config.webchat_region,
      });
    },
    onWebchatPortMessage(message, iframe) {
      if (!message || typeof message !== "object") return;
      if (message.v !== WEBCHAT_SCHEMA_VERSION) return;
      switch (message.type) {
        case "webchat:expanded":
          // CSS media query picks floating vs full-screen (see .expanded); JS just toggles.
          iframe.classList.add("expanded");
          trackEvent(EAP_LIVE_CHAT_OPENED, { provider: "twilio_flex" });
          break;
        case "webchat:collapsed":
          iframe.classList.remove("expanded");
          break;
        case "webchat:error":
          // Couldn't boot (bad token, unprovisioned region, outage). Report it and take
          // the dead iframe down rather than leave an invisible overlay on the page.
          Sentry.captureMessage(
            `Twilio webchat failed to boot: ${message.code || "unknown"}`,
            {
              level: "error",
              tags: { stage: "webchat_error", code: message.code || "unknown" },
              extra: { message: message.message },
            },
          );
          iframe.classList.remove("expanded");
          iframe.style.display = "none";
          break;
      }
    },
  },
  computed: {
    text() {
      return this.getText.loggedIn.eapPage;
    },
    darkMode() {
      return this.$store.getters.darkMode;
    },
    skin() {
      return this.$store.getters.skin;
    },
    defaults() {
      return (this.eapCustomisation && this.eapCustomisation.defaults) || {};
    },
    // "Your Employee Assistance Programme (EAP)" → the bracketed acronym takes the gradient.
    titleParts() {
      const title = this.defaults.eap_title || "";
      const match = title.match(/^(.*\S)\s+(\([^()]+\))$/);
      return match
        ? { lead: `${match[1]} `, emphasis: match[2] }
        : { lead: title, emphasis: "" };
    },
    isDmhEnabled() {
      return isAffirmative(
        this.eapCustomisation && this.eapCustomisation.dmh_button,
      );
    },
    dmhBookingPath() {
      return "/session-booking?service_type=sl_dmh";
    },
    contactChannels() {
      return extractEapContactChannels(this.defaults);
    },
    isPhoneTileShown() {
      return this.contactChannels.callNumbers.length > 0;
    },
    isMessagingTileShown() {
      return hasMessagingChannel(this.contactChannels);
    },
    hasImmediateChannels() {
      return this.isPhoneTileShown || this.isMessagingTileShown;
    },
    messagingRows() {
      const { hasLiveChat, whatsappNumbers, smsNumbers } = this.contactChannels;
      const { messaging } = this.text;
      const rows = [];
      if (hasLiveChat) {
        rows.push({
          key: "live-chat",
          channel: "live_chat",
          icon: "chat",
          label: messaging.liveChatLabel,
          value: messaging.liveChat,
          href: null,
          ariaLabel: null,
          region: null,
          opensNewTab: false,
        });
      }
      whatsappNumbers.forEach((whatsappNumber, index) => {
        const formattedNumber = this.formatContactNumber(whatsappNumber);
        rows.push({
          key: `whatsapp-${index}`,
          channel: "whatsapp",
          icon: "whatsapp",
          label: messaging.whatsapp,
          value: formattedNumber,
          href: whatsappNumber.href,
          ariaLabel: `${messaging.whatsappAriaLabel}, ${formattedNumber}`,
          region: whatsappNumber.region,
          opensNewTab: true,
        });
      });
      smsNumbers.forEach((smsNumber, index) => {
        const formattedNumber = this.formatContactNumber(smsNumber);
        rows.push({
          key: `sms-${index}`,
          channel: "sms",
          icon: "sms",
          label: messaging.sms,
          value: formattedNumber,
          href: smsNumber.href,
          ariaLabel: `${messaging.smsAriaLabel}, ${formattedNumber}`,
          region: smsNumber.region,
          opensNewTab: false,
        });
      });
      return rows;
    },
    appointmentCards() {
      const { appointments } = this.text;
      return this.upcomingAppointments.map((appointment) => {
        const { localStartTime, localEndTime } = getAppointmentTimeDisplay(
          appointment,
        );
        const startClock = localStartTime.format("HH:mm");
        const timeRange = localEndTime
          ? `${startClock} – ${localEndTime.format("HH:mm")}`
          : startClock;
        const title = appointment.serviceName || appointments.defaultTitle;
        const clinicianName =
          appointment.clinician && appointment.clinician.name;
        const fullDate = localStartTime.format("D MMMM");
        return {
          id: appointment.appointmentId,
          appointment,
          title,
          clinicianLine: clinicianName
            ? appointments.withClinician.replace("{clinician}", clinicianName)
            : null,
          month: localStartTime.format("MMM"),
          day: localStartTime.format("D"),
          fullDate,
          timeRange,
          accessibleSummary: `${title}, ${fullDate}, ${timeRange}`,
          joinPath: `/session/dmh/${appointment.appointmentId}`,
        };
      });
    },
    services() {
      return selectEnabledEapServices(
        this.eapCustomisation && this.eapCustomisation.services_offered,
      );
    },
    // A dynamic theme's base_hex is applied asynchronously, so read it directly rather than
    // waiting for its compiled --brand-primary to land.
    ctaColour() {
      const { client } = this.$store.state;
      const dynamicThemeColour =
        client && client.skin === 0 ? client.base_hex : null;
      return resolveCtaColour([dynamicThemeColour, this.themeBrandColour]);
    },
    pageStyle() {
      return {
        ...deriveCtaTokens(this.ctaColour, this.darkMode ? "dark" : "light"),
        "--eap-font-family": TYPEFACES[EAP_TYPEFACE],
      };
    },
  },
};
</script>

<style lang="less">
// The portal's DMSans face is declared with font-weight: normal, which pins the variable
// font to 400 and fakes bold. This range lets headings use the real weights.
@font-face {
  font-family: "EapDMSans";
  src: url("../assets/fonts/DMSans-VariableFont_opsz,wght.ttf");
  font-weight: 100 1000;
  font-style: normal;
}

#eap-redesign {
  --eap-bg: #f7f7fb;
  --eap-surface: #ffffff;
  --eap-text: #0f1123;
  --eap-text-mid: #3b4256;
  --eap-text-muted: #667085;
  --eap-border: #e6e7ef;
  --eap-success: #16a34a;
  --eap-success-soft: #dcfce7;
  --eap-success-text: #15803d;
  --eap-glass: rgba(255, 255, 255, 0.78);
  --eap-glass-strong: rgba(255, 255, 255, 0.88);
  --eap-glass-border: rgba(255, 255, 255, 0.9);
  --eap-hero-from: #ffffff;
  --eap-hero-border: #ffffff;
  --eap-radius-md: 18px;
  --eap-radius-lg: 28px;
  --eap-radius-pill: 999px;
  --eap-shadow-sm: 0 1px 2px rgba(16, 17, 35, 0.04),
    0 2px 8px rgba(16, 17, 35, 0.05);
  --eap-shadow-md: 0 2px 4px rgba(16, 17, 35, 0.04),
    0 12px 32px rgba(16, 17, 35, 0.08);
  --eap-shadow-lg: 0 24px 60px -12px ~"rgb(var(--eap-primary-deep-rgb) / 0.35)";
  --eap-ease: cubic-bezier(0.2, 0.7, 0.2, 1);

  background: var(--eap-bg);
  color: var(--eap-text);
  font-family: var(--eap-font-family);
  -webkit-font-smoothing: antialiased;
  color-scheme: light;

  &.eap--dark {
    --eap-bg: #0b0d18;
    --eap-surface: #151827;
    --eap-text: #eef0f7;
    --eap-text-mid: #c4c8d6;
    --eap-text-muted: #9ba1b5;
    --eap-border: #2a2e44;
    --eap-success: #22c55e;
    --eap-success-soft: rgba(34, 197, 94, 0.16);
    --eap-success-text: #4ade80;
    --eap-glass: rgba(21, 24, 39, 0.72);
    --eap-glass-strong: rgba(21, 24, 39, 0.86);
    --eap-glass-border: rgba(255, 255, 255, 0.1);
    --eap-hero-from: #151827;
    --eap-hero-border: #2a2e44;
    --eap-shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.3), 0 2px 8px rgba(0, 0, 0, 0.25);
    --eap-shadow-md: 0 2px 4px rgba(0, 0, 0, 0.3),
      0 12px 32px rgba(0, 0, 0, 0.4);
    color-scheme: dark;
  }

  * {
    box-sizing: border-box;
  }

  h1,
  h2,
  h3,
  p,
  ul {
    font-family: inherit;
    color: inherit;
    letter-spacing: normal;
    padding: 0;
  }

  @media (prefers-reduced-motion: no-preference) {
    .eap-hero,
    .eap-tile,
    .eap-service {
      transition: background-color 0.3s, border-color 0.3s, color 0.3s;
    }
  }

  .eap-sprite {
    position: absolute;
  }

  .eap-icon {
    display: block;
    flex-shrink: 0;
    transition: transform 0.2s var(--eap-ease);
  }

  .eap-loading {
    display: flex;
    justify-content: center;
    padding: 120px 0;
  }

  .eap-layout {
    max-width: 1200px;
    margin: 0 auto;
    padding: 28px 24px 72px;
    display: flex;
    flex-direction: column;
    gap: 56px;
  }

  .eap-section-head {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 16px 32px;
    flex-wrap: wrap;
    margin-bottom: 24px;

    h2 {
      font-size: clamp(26px, 3vw, 34px);
      font-weight: 800;
      letter-spacing: -0.025em;
      line-height: 1.15;
      margin: 0;
    }

    p {
      margin: 0;
      color: var(--eap-text-muted);
      font-size: 16px;
      line-height: 1.55;
      max-width: 420px;
    }
  }

  .eap-kicker {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: var(--eap-primary-text);
    margin-bottom: 10px;

    &::before {
      content: "";
      width: 18px;
      height: 2px;
      border-radius: 2px;
      background: currentColor;
    }
  }

  a:focus-visible,
  button:focus-visible {
    outline: 3px solid var(--eap-primary-border);
    outline-offset: 3px;
  }

  .eap-sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }

  // Hero
  .eap-hero {
    position: relative;
    overflow: hidden;
    border-radius: var(--eap-radius-lg);
    background: linear-gradient(
      135deg,
      var(--eap-hero-from) 0%,
      var(--eap-primary-light) 100%
    );
    border: 1px solid var(--eap-hero-border);
    box-shadow: var(--eap-shadow-md);
    display: grid;
    grid-template-columns: minmax(0, 1.1fr) minmax(0, 0.9fr);
    gap: 40px;
    padding: 56px;
    isolation: isolate;

    &::before,
    &::after {
      content: "";
      position: absolute;
      border-radius: 50%;
      filter: blur(60px);
      z-index: -1;
      pointer-events: none;
    }

    &::before {
      width: 420px;
      height: 420px;
      right: -80px;
      top: -140px;
      background: ~"rgb(var(--eap-accent-rgb) / 0.28)";
    }

    &::after {
      width: 360px;
      height: 360px;
      left: -120px;
      bottom: -200px;
      background: ~"rgb(var(--eap-primary-rgb) / 0.18)";
    }
  }

  .eap-eyebrow {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    font-weight: 600;
    color: var(--eap-primary-deep);
    background: var(--eap-glass);
    border: 1px solid var(--eap-primary-border);
    border-radius: var(--eap-radius-pill);
    padding: 6px 14px 6px 8px;
    margin-bottom: 22px;
    box-shadow: var(--eap-shadow-sm);
  }

  .eap-eyebrow__dot {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: var(--eap-primary);
    color: var(--eap-on-primary);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .eap-hero__title {
    font-size: clamp(34px, 4.6vw, 56px);
    line-height: 1.04;
    font-weight: 800;
    letter-spacing: -0.035em;
    margin: 0 0 20px;
    color: var(--eap-text);
    text-align: left;
  }

  .eap-gradient-text {
    background: linear-gradient(
      90deg,
      var(--eap-primary) 0%,
      var(--eap-accent) 100%
    );
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
  }

  .eap-hero__intro-wrap {
    margin: 0 0 26px;
    max-width: 540px;
  }

  .eap-hero__intro {
    font-size: 18px;
    line-height: 1.6;
    color: var(--eap-text-mid);

    &.eap-hero__intro--collapsed {
      max-height: 6.4em;
      overflow: hidden;
    }

    &.eap-hero__intro--collapsed.eap-hero__intro--overflowing {
      -webkit-mask-image: linear-gradient(to bottom, #000 55%, transparent);
      mask-image: linear-gradient(to bottom, #000 55%, transparent);
    }

    p {
      margin: 0 0 12px;
    }

    a {
      color: var(--eap-primary-text);
    }
  }

  .eap-chips {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin: 0 0 30px;
    padding: 0;
    list-style: none;

    li {
      display: inline-flex;
      align-items: center;
      gap: 7px;
      font-size: 13.5px;
      font-weight: 600;
      color: var(--eap-text);
      background: var(--eap-glass);
      border: 1px solid var(--eap-border);
      border-radius: var(--eap-radius-pill);
      padding: 7px 13px 7px 10px;

      .eap-icon {
        color: var(--eap-primary);
      }
    }
  }

  .eap-choices {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
    max-width: 560px;

    &.eap-choices--single {
      grid-template-columns: minmax(0, 1fr);
      max-width: 400px;
    }
  }

  .eap-choice {
    display: flex;
    flex-direction: column;
    gap: 6px;
    text-decoration: none;
    color: var(--eap-text);
    background: var(--eap-surface);
    border: 1.5px solid var(--eap-border);
    border-radius: 20px;
    padding: 18px;
    box-shadow: var(--eap-shadow-sm);
    transition: transform 0.2s var(--eap-ease), box-shadow 0.2s,
      border-color 0.2s;

    &:hover {
      transform: translateY(-3px);
      border-color: var(--eap-primary);
      box-shadow: var(--eap-shadow-md);
      text-decoration: none;
      color: var(--eap-text);

      .eap-choice__cta {
        background: var(--eap-primary-dark);
      }

      .eap-icon--arrow {
        transform: translateX(3px);
      }
    }
  }

  .eap-choice__top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    margin-bottom: 6px;
  }

  .eap-choice__icon {
    width: 42px;
    height: 42px;
    border-radius: 13px;
    background: var(--eap-primary);
    color: var(--eap-on-primary);
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 8px 16px -8px ~"rgb(var(--eap-primary-rgb) / 0.8)";
  }

  .eap-choice__badge {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    font-weight: 700;
    color: var(--eap-success-text);
    background: var(--eap-success-soft);
    border-radius: var(--eap-radius-pill);
    padding: 4px 9px;
    white-space: nowrap;
  }

  .eap-choice__dot {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: var(--eap-success);
  }

  .eap-choice__title {
    font-size: 17px;
    font-weight: 800;
    letter-spacing: -0.01em;
  }

  .eap-choice__copy {
    font-size: 13.5px;
    line-height: 1.5;
    color: var(--eap-text-muted);
  }

  .eap-choice__cta {
    margin-top: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    min-height: 44px;
    border-radius: var(--eap-radius-pill);
    background: var(--eap-primary);
    color: var(--eap-on-primary);
    font-size: 14.5px;
    font-weight: 600;
    transition: background 0.2s;
  }

  .eap-all-ways {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    margin-top: 16px;
    font-size: 14px;
    font-weight: 600;
    color: var(--eap-primary-deep);
    text-decoration: none;
    border-bottom: 1.5px solid var(--eap-primary-border);
    padding-bottom: 2px;

    &:hover {
      color: var(--eap-primary-text);
      border-color: var(--eap-primary);
      text-decoration: none;
    }
  }

  .eap-intro-toggle {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    margin-top: 8px;
    padding: 0 0 2px;
    background: none;
    border: none;
    border-bottom: 1.5px solid var(--eap-primary-border);
    font-family: inherit;
    font-size: 14px;
    font-weight: 600;
    color: var(--eap-primary-deep);
    cursor: pointer;

    &:hover {
      color: var(--eap-primary-text);
      border-color: var(--eap-primary);
    }

    // Bootstrap's reboot rings every focused button; keep the ring for keyboard focus only.
    &:focus:not(:focus-visible) {
      outline: none;
    }

    &[aria-expanded="true"] .eap-intro-toggle__icon {
      transform: rotate(180deg);
    }
  }

  .eap-hero__media {
    position: relative;
    align-self: center;
  }

  .eap-hero--intro-expanded .eap-hero__media {
    align-self: start;
  }

  .eap-hero__image {
    display: block;
    width: 100%;
    max-width: 100%;
    aspect-ratio: ~"4 / 4.2";
    object-fit: cover;
    object-position: 60% 30%;
    border-radius: 22px;
    box-shadow: var(--eap-shadow-lg);
  }

  .eap-float-card {
    position: absolute;
    right: -18px;
    top: 28px;
    display: flex;
    align-items: center;
    gap: 12px;
    background: var(--eap-glass-strong);
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    border: 1px solid var(--eap-glass-border);
    border-radius: 16px;
    padding: 12px 16px;
    box-shadow: var(--eap-shadow-md);

    strong {
      display: block;
      font-size: 14px;
      font-weight: 700;
      color: var(--eap-text);
    }

    span {
      display: block;
      font-size: 12.5px;
      color: var(--eap-text-muted);
      margin-top: 2px;
    }
  }

  .eap-pulse {
    position: relative;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: #22c55e;
    flex-shrink: 0;
    margin: 0 4px;

    &::after {
      content: "";
      position: absolute;
      inset: -5px;
      border-radius: 50%;
      border: 2px solid #22c55e;
      opacity: 0.5;
    }
  }

  @media (prefers-reduced-motion: no-preference) {
    .eap-pulse::after {
      animation: eap-pulse 2s ease-out infinite;
    }
  }

  // Upcoming appointments
  .eap-appointments {
    display: flex;
    flex-direction: column;
    gap: 10px;
    background: var(--eap-surface);
    border: 1px solid var(--eap-border);
    border-radius: var(--eap-radius-lg);
    box-shadow: var(--eap-shadow-md);
    padding: 10px;
  }

  .eap-appointment {
    display: grid;
    grid-template-columns: auto minmax(0, 1fr) auto;
    align-items: center;
    gap: 24px;
    padding: 14px 18px 14px 14px;
    border-radius: 20px;
    background: linear-gradient(
      90deg,
      var(--eap-primary-light),
      var(--eap-surface) 60%
    );
  }

  .eap-date-tile {
    width: 84px;
    height: 92px;
    border-radius: 18px;
    background: var(--eap-primary);
    color: var(--eap-on-primary);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-shadow: 0 10px 24px -10px ~"rgb(var(--eap-primary-rgb) / 0.8)";
  }

  .eap-date-tile__month {
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    opacity: 0.85;
  }

  .eap-date-tile__day {
    font-size: 34px;
    font-weight: 800;
    line-height: 1;
    letter-spacing: -0.03em;
    margin-top: 4px;
  }

  .eap-appointment__meta {
    min-width: 0;

    h3 {
      font-size: 18px;
      font-weight: 700;
      letter-spacing: -0.01em;
      margin: 0 0 4px;
    }
  }

  .eap-appointment__clinician {
    font-size: 14.5px;
    color: var(--eap-text-muted);
    margin: 0 0 8px;
  }

  .eap-time-chip {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
    font-weight: 600;
    color: var(--eap-primary-deep);
    background: var(--eap-surface);
    border: 1px solid var(--eap-primary-border);
    border-radius: var(--eap-radius-pill);
    padding: 5px 10px;
  }

  .eap-appointment__actions {
    display: flex;
    gap: 10px;
  }

  // Services
  .eap-services {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    gap: 16px;
    margin: 0;
    padding: 0;
    list-style: none;
  }

  .eap-service {
    display: flex;
    flex-direction: column;
    gap: 6px;
    background: var(--eap-surface);
    border: 1px solid var(--eap-border);
    border-radius: var(--eap-radius-md);
    padding: 22px;
    box-shadow: var(--eap-shadow-sm);
    transition: transform 0.25s var(--eap-ease), box-shadow 0.25s,
      border-color 0.25s;

    &:hover {
      transform: translateY(-3px);
      box-shadow: var(--eap-shadow-md);
      border-color: var(--eap-primary-border);
    }

    h3 {
      font-size: 16.5px;
      font-weight: 700;
      letter-spacing: -0.01em;
      margin: 0;
    }

    p {
      margin: 0;
      font-size: 14.5px;
      line-height: 1.55;
      color: var(--eap-text-mid);
    }
  }

  .eap-service__icon {
    width: 46px;
    height: 46px;
    border-radius: 14px;
    background: linear-gradient(135deg, var(--eap-primary), var(--eap-accent));
    color: var(--eap-on-primary);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 10px;
    box-shadow: 0 10px 20px -10px ~"rgb(var(--eap-primary-rgb) / 0.8)";
  }

  // Support channels
  .eap-bento {
    display: grid;
    grid-template-columns: repeat(12, minmax(0, 1fr));
    gap: 20px;
  }

  .eap-tile {
    position: relative;
    background: var(--eap-surface);
    border: 1px solid var(--eap-border);
    border-radius: var(--eap-radius-lg);
    padding: 30px;
    box-shadow: var(--eap-shadow-sm);
    display: flex;
    flex-direction: column;

    h3 {
      font-size: 22px;
      font-weight: 800;
      letter-spacing: -0.02em;
      margin: 0 0 10px;
    }

    p {
      font-size: 15px;
      line-height: 1.6;
      color: var(--eap-text-mid);
      margin: 0 0 12px;
    }
  }

  @media (prefers-reduced-motion: no-preference) {
    .eap-tile {
      transition: box-shadow 0.4s;
    }
  }

  .eap-tile--contact {
    grid-column: span 6;
    border-top: 4px solid var(--eap-primary);

    &.eap-tile--full {
      grid-column: ~"1 / -1";
    }

    .eap-rows {
      padding-top: 8px;
    }
  }

  .eap-tile--highlight {
    box-shadow: 0 0 0 3px var(--eap-primary-border), var(--eap-shadow-md);
  }

  .eap-tile__top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 22px;
  }

  .eap-tile__icon {
    width: 56px;
    height: 56px;
    border-radius: 18px;
    background: var(--eap-primary-light);
    color: var(--eap-primary-text);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .eap-tile__label {
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: var(--eap-primary-text);
    margin-bottom: 4px;
  }

  .eap-availability {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    font-size: 12.5px;
    font-weight: 700;
    color: var(--eap-success-text);
    background: var(--eap-success-soft);
    border-radius: var(--eap-radius-pill);
    padding: 6px 11px;
    white-space: nowrap;

    &::before {
      content: "";
      width: 7px;
      height: 7px;
      border-radius: 50%;
      background: var(--eap-success);
    }
  }

  .eap-rows {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .eap-row {
    display: flex;
    align-items: center;
    gap: 14px;
    width: 100%;
    text-align: left;
    font-family: inherit;
    background: var(--eap-bg);
    border: 1px solid var(--eap-border);
    border-radius: 16px;
    padding: 12px 14px;
    cursor: pointer;
    text-decoration: none;
    color: var(--eap-text);
    transition: border-color 0.2s, background 0.2s,
      transform 0.2s var(--eap-ease);

    &:hover {
      border-color: var(--eap-primary-border);
      background: var(--eap-surface);
      transform: translateX(2px);
      text-decoration: none;
      color: var(--eap-text);
    }

    small {
      display: block;
      font-size: 12px;
      font-weight: 600;
      color: var(--eap-text-muted);
      text-transform: uppercase;
      letter-spacing: 0.06em;
    }

    b {
      display: block;
      font-size: 14.5px;
      font-weight: 700;
      margin-top: 2px;
      overflow-wrap: anywhere;
    }
  }

  .eap-row__icon {
    width: 38px;
    height: 38px;
    border-radius: 12px;
    background: var(--eap-surface);
    border: 1px solid var(--eap-border);
    color: var(--eap-primary-text);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .eap-row__text {
    flex: 1;
    min-width: 0;
  }

  .eap-row__chevron {
    color: var(--eap-text-muted);
  }

  .eap-row--primary {
    background: var(--eap-primary);
    border-color: var(--eap-primary);
    color: var(--eap-on-primary);

    .eap-row__icon {
      background: rgba(255, 255, 255, 0.16);
      border-color: transparent;
      color: var(--eap-on-primary);
    }

    small {
      color: var(--eap-on-primary);
      opacity: 0.8;
    }

    .eap-row__chevron {
      color: var(--eap-on-primary);
    }

    &:hover {
      background: var(--eap-primary-dark);
      border-color: var(--eap-primary-dark);
      color: var(--eap-on-primary);
    }
  }

  .eap-note {
    display: flex;
    gap: 12px;
    align-items: flex-start;
    background: var(--eap-bg);
    border-radius: 14px;
    padding: 14px 16px;
    margin-top: 4px;

    .eap-icon {
      color: var(--eap-primary);
      margin-top: 2px;
    }

    p {
      margin: 0;
      font-size: 14px;
    }
  }

  .eap-tile--dmh {
    grid-column: ~"1 / -1";
    flex-direction: row;
    align-items: center;
    gap: 20px;
    padding: 22px 26px;
    background: transparent;
    border: 1px dashed var(--eap-border);
    box-shadow: none;

    h3 {
      font-size: 17px;
      font-weight: 700;
      margin: 0 0 4px;
    }

    p {
      font-size: 14px;
      margin: 0 0 8px;
      color: var(--eap-text-muted);
    }

    .eap-tile__label {
      display: block;
      color: var(--eap-text-muted);
      margin-bottom: 2px;
    }

    .eap-button {
      flex-shrink: 0;
    }
  }

  .eap-dmh__icon {
    width: 46px;
    height: 46px;
    border-radius: 14px;
    background: var(--eap-surface);
    border: 1px solid var(--eap-border);
    color: var(--eap-text-muted);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    align-self: flex-start;
  }

  .eap-dmh__body {
    flex: 1;
    min-width: 0;
  }

  .eap-dmh__points {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-wrap: wrap;
    gap: 4px 16px;

    li {
      font-size: 13px;
      color: var(--eap-text-muted);
      display: flex;
      align-items: center;
      gap: 6px;

      &::before {
        content: "";
        width: 4px;
        height: 4px;
        border-radius: 50%;
        background: var(--eap-text-muted);
      }
    }
  }

  .eap-button {
    font-family: inherit;
    font-weight: 600;
    font-size: 15px;
    line-height: 1;
    border-radius: var(--eap-radius-pill);
    padding: 14px 22px;
    min-height: 48px;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    border: 1.5px solid transparent;
    text-decoration: none;
    white-space: nowrap;
    transition: transform 0.2s var(--eap-ease), background 0.2s, box-shadow 0.2s,
      border-color 0.2s, color 0.2s;

    &:hover {
      text-decoration: none;

      .eap-icon--arrow {
        transform: translateX(3px);
      }
    }

    &:active {
      transform: translateY(1px);
    }
  }

  .eap-button--primary {
    background: var(--eap-primary);
    color: var(--eap-on-primary);
    box-shadow: 0 8px 20px -8px ~"rgb(var(--eap-primary-rgb) / 0.7)";

    &:hover {
      background: var(--eap-primary-dark);
      color: var(--eap-on-primary);
      box-shadow: 0 12px 24px -8px ~"rgb(var(--eap-primary-rgb) / 0.75)";
    }
  }

  .eap-button--outline {
    background: var(--eap-surface);
    border-color: var(--eap-border);
    color: var(--eap-text);

    &:hover {
      border-color: var(--eap-primary);
      color: var(--eap-primary-text);
    }
  }

  @media (prefers-reduced-motion: no-preference) {
    .eap-reveal {
      opacity: 0;
      transform: translateY(18px);
      transition: opacity 0.6s var(--eap-ease), transform 0.6s var(--eap-ease);

      &.is-revealed {
        opacity: 1;
        transform: none;
      }
    }
  }

  @media (max-width: 1080px) {
    .eap-tile--dmh {
      flex-wrap: wrap;

      .eap-button {
        margin-left: 66px;
      }
    }
  }

  @media (max-width: 900px) {
    .eap-layout {
      gap: 44px;
    }

    .eap-hero {
      grid-template-columns: 1fr;
      padding: 40px 32px;
    }

    .eap-hero__media {
      max-width: 520px;
    }

    .eap-hero__image {
      aspect-ratio: ~"16 / 10";
    }

    .eap-float-card {
      right: 16px;
      top: 16px;
    }

    .eap-appointment {
      grid-template-columns: auto minmax(0, 1fr);
    }

    .eap-appointment__actions {
      grid-column: ~"1 / -1";

      .eap-button {
        flex: 1;
      }
    }
  }

  @media (max-width: 720px) {
    .eap-tile--contact {
      grid-column: ~"1 / -1";
    }
  }

  @media (max-width: 600px) {
    .eap-services {
      grid-template-columns: 1fr;
      gap: 12px;
    }

    .eap-service {
      flex-direction: row;
      flex-wrap: wrap;
      align-items: center;
      column-gap: 14px;
      padding: 18px;

      h3 {
        flex: 1;
        min-width: 0;
      }

      p {
        flex-basis: 100%;
      }
    }

    .eap-service__icon {
      margin-bottom: 0;
    }

    .eap-appointment {
      gap: 16px;
      padding: 12px;
    }

    .eap-date-tile {
      width: 68px;
      height: 76px;
    }

    .eap-date-tile__day {
      font-size: 28px;
    }

    .eap-appointment__actions {
      flex-direction: column;
    }

    .eap-layout {
      padding: 16px 16px 48px;
      gap: 36px;
    }

    .eap-hero {
      padding: 28px 20px 44px;
      border-radius: 22px;
      gap: 28px;
    }

    .eap-hero__intro {
      font-size: 16px;
    }

    .eap-choices {
      grid-template-columns: 1fr;
    }

    .eap-tile {
      padding: 22px;
      border-radius: 22px;
    }

    .eap-tile--dmh {
      padding: 18px;

      .eap-button {
        margin-left: 0;
        width: 100%;
      }
    }
  }
}

@keyframes eap-pulse {
  0% {
    transform: scale(0.6);
    opacity: 0.7;
  }
  100% {
    transform: scale(1.6);
    opacity: 0;
  }
}

// Twilio webchat iframe — appended to <body>, so top-level (not under #eap-redesign).
// This id must match the one set on the iframe in openTwilioWebchat().
#twilio-webchat-iframe {
  position: fixed;
  // Offsets from the webchat (16px default, per-consumer override echoed on
  // webchat:ready), raised to clear the ~56px bottom-right a11y widget.
  right: var(--webchat-offset-right, 16px);
  bottom: var(--webchat-offset-bottom, 16px);
  width: 40px;
  height: 40px;
  border: 0;
  z-index: 100000;
  background: transparent;

  // Floating corner panel; max-height keeps it clip-free above Twilio's ~646px window.
  &.expanded {
    width: 400px;
    height: 700px;
    max-height: calc(100vh - 80px);
  }

  // Narrow/short viewport: stretch to fill above the a11y widget. Keep right/bottom
  // (the vars) so the corner stays anchored on expand — only top/left move.
  @media (max-width: 600px), (max-height: 725px) {
    &.expanded {
      top: 16px;
      left: 16px;
      right: 16px;
      // iframes don't fill via height:auto (defaults to 150px) — set them explicitly.
      width: calc(100vw - 32px);
      height: calc(100vh - var(--webchat-offset-bottom, 16px) - 16px);
      max-height: none;
    }
  }
}
</style>
